import type { PlayerDefeatRuntime } from "../application/player-defeat-runtime";

export class PlayerDefeatFeedback {
  private readonly unsubscribe: () => void;

  public constructor(
    private readonly runtime: PlayerDefeatRuntime,
    private readonly element: HTMLElement,
  ) {
    this.unsubscribe = runtime.subscribe(() => {
      this.render();
    });
  }

  public destroy(): void {
    this.unsubscribe();
  }

  private render(): void {
    const waiting = this.runtime.getSnapshot().state === "waiting";
    this.element.hidden = !waiting;
    if (waiting) {
      this.element.textContent = "Good try! Finding a safe spot…";
    }
  }
}

export const installPlayerDefeatFeedback = (
  documentScope: Document,
  runtime: PlayerDefeatRuntime,
): PlayerDefeatFeedback => {
  const element = documentScope.getElementById("player-defeat-feedback");
  if (element === null) {
    throw new Error("Missing player defeat feedback element");
  }
  return new PlayerDefeatFeedback(runtime, element);
};
